module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Background</span></div>\r\n<div id=\"propStyleBackgroundColor\" class=\"prop-detail\"></div>\r\n<div id=\"propStyleBackgroundPicture\" class=\"prop-detail\"></div>\r\n<div id=\"propStyleBackgroundGradientColor\" class=\"prop-detail\"></div>\r\n<div id=\"propStyleAdvancedBackgroundColor\" class=\"prop-detail\"></div>\r\n")
  }
  return __output;

}